module.exports = __webpack_public_path__ + "img/no-data_piechart.12e38b21.svg";